/**
 * The venue detail page's tabs, and how they map to the URL (BON-235).
 *
 * Extracted from `VenueDetailPage` so the tab bar, the panel switch and the
 * page can each import what they need without any of them owning the set.
 *
 * The active tab is driven by the `:tab` URL segment, so tabs are deep-linkable
 * and survive a refresh or a browser back.
 */
export const TABS = ['Details', 'Relationship', 'Marketing', 'Workshops'] as const;
export type Tab = (typeof TABS)[number];

/** URL path segment for each tab. */
export const TAB_SLUGS: Record<Tab, string> = {
  Details: 'details',
  Relationship: 'relationship',
  Marketing: 'marketing',
  Workshops: 'workshops',
};

const SLUG_TO_TAB: Record<string, Tab> = {
  details: 'Details',
  relationship: 'Relationship',
  marketing: 'Marketing',
  workshops: 'Workshops',
};

export const DEFAULT_TAB: Tab = 'Details';

/** Segments are case-insensitive; unknown or missing falls back to Details. */
export function tabFromSlug(slug: string | undefined): Tab {
  return (slug && SLUG_TO_TAB[slug.toLowerCase()]) || DEFAULT_TAB;
}
